import React from "react";
import { MagnifyingGlass, Funnel } from "@phosphor-icons/react";

/** Single-input search bar with Enter-to-apply and an explicit Apply button. */
export default function LeadsSearchBar({ q, setQ, onApply }) {
  return (
    <div className="flex items-center gap-2">
      <MagnifyingGlass size={16} />
      <input
        data-testid="search-input"
        placeholder="Search name, phone, email, address, ID, sub-ID…"
        className="flex-1 border border-black px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-black"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onApply()}
      />
      <button
        onClick={onApply}
        data-testid="search-apply"
        className="border border-black px-3 py-2 text-xs uppercase tracking-widest hover:bg-black hover:text-white transition-colors duration-100"
      >
        <Funnel size={12} className="inline mr-1" /> Apply
      </button>
    </div>
  );
}
